let token = "4453e2d25a25172b02202e78a1e78e";
export default async function fetchDato(body){
    return await fetch(
        'https://graphql.datocms.com/',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                query: body
            }),
        }
    ).then( r=> r.json() )
    .then( r=> r.data )

}